/**
 * iOS/appstore version/1.9.0 build/6824
 */
import Cache from 'c-cache';
import PbAjax from '../../lib/pbajax';
import notification from 'c-notification';
import publicpb from '../../base/public.pb';
import indexpb from './visitor.pb';
import lang from '../../lang/index';

const cache = new Cache({
    prefix: 'pcuplive'
});

let pbajax = new PbAjax();
let visitor = {
    register() {

        let self = this;
        let _lang = UP.Global.systemLanguage;
        let countryCode = '';//_lang.split('-')[1].toUpperCase();

        let businessData = new indexpb.Visitor.RegisterH5.Request({
            // countryCode // 经纬度判断，-》IP库判断
            countryCode: ''
        });

        let defer = $.Deferred();
        // console.warn('-------游客设备：Android/' + UP.Global.channel + ' version/1.9.0  smd/' + deviceId);
        UP.Global.DA.add({
            eventName: 'visitorRegisterBegin',
            action: 'click'
        });

        pbajax.do({
                service: 'safe',
                api: '/visitor/register/h5'
            },
            businessData,
            function(res) {

                let dataWrap = publicpb.Result.decode(res);
                let data;
                
                if (dataWrap.code == 1) {
                    data = indexpb.Visitor.RegisterH5.Response.decode(dataWrap.data.value);

                    let userInfo = Object.assign({}, data.profile, self.parseData(data.profile));
                    // console.warn('------游客注册结果：' , userInfo);

                    UP.Global.DA.add({
                        eventName: 'visitorRegisterSuccess',
                        action: 'click'
                    });
                    
                    fbq('track', 'VisitorRegisterSuccess');
                    
                    $.channel.emit('registerVisitorSuccess', userInfo);
                    // console.log('registerVisitorSuccess', userInfo);
                    defer.resolve(userInfo);
                } else {
                    // notification.simple('游客登录失败，请使用其他方式登录');
                    $.channel.emit('login');
                    
                    defer.reject();
                }

            },
            () => {
                // notification.simple('游客登录失败，请使用其他方式登录');
                $.channel.emit('login');
                
                defer.reject();
            },
            () => {
                // notification.simple('游客登录失败，请使用其他方式登录');
                $.channel.emit('login');
                
                defer.reject();
            }
        );
    },
    /*
     * 解析数据
     */
    parseData(data) {
        let balance = data.balance || {};

        return {
            uid: this.longToString(data.uid), // 用户UID
            balance: {
                diamond: this.longToInt(balance.diamond),
                bill: this.longToInt(balance.bill),
                inBill: this.longToInt(balance.inBill),
                outDiamond: this.longToInt(balance.outDiamond)
            },
            exp: this.longToInt(data.exp), // 用户经验值
            currentExp: this.longToInt(data.currentExp), //当前级的经验值
            nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
            chatroomid: this.longToString(data.chatroomid),
            officialAuth: data.officialAuth || 0, // 大V认证标识 1是 0否
            hostStatus: true
        }
    },

    longToString(value) {
        return window.longToString(value);
    },

    longToInt(value) {
        value = this.longToString(value);

        return parseInt(value, 10) || 0;
    }
};

export default visitor;



// WEBPACK FOOTER //
// ./js/component/visitor/index.js